import classNames from 'classnames';
import React__default, { useContext } from 'react';
import { AppContext } from '../../app-context.js';
import Bottompagination from '../Pagination/BottomPagination.js';
import AppPagination from '../Pagination/pagination.js';
import ResponsiveContainer from '../responsive-container/ResponsiveContainer.js';
import Skeleton from '../skeleton/Skeleton.js';
import Styles from './ListContainer.module.scss.js';

const ListContainer = ({ title, children, isPaginated, className, titleClassName, contentClassName, currentPage, pagesCount, handleClick, isMobile, showLoadMore }) => {
    const { companyId } = useContext(AppContext);
    return (React__default.createElement("div", { className: classNames(Styles.main, className) },
        React__default.createElement("div", { className: classNames(Styles.header, isMobile && Styles.isMobile) },
            typeof title === "string" && React__default.createElement("h3", { className: classNames(Styles.title, titleClassName) }, title),
            typeof title === "object" && title,
            isPaginated && (React__default.createElement("div", { className: classNames(Styles.paginationContainer) },
                React__default.createElement("div", { className: Styles.pageCount }, pagesCount ? `${currentPage}/${pagesCount}` : React__default.createElement(Skeleton, { width: "50px" })),
                React__default.createElement(AppPagination, { currentPage: currentPage, pagesCount: pagesCount, handleClick: handleClick, isMobile: true })))),
        React__default.createElement(ResponsiveContainer, { className: classNames(Styles.content, contentClassName) }, children),
        isPaginated && (React__default.createElement("div", { className: classNames(Styles.bottomPagination, companyId && Styles.bottomPaginationLoggedIn) },
            React__default.createElement(Bottompagination, { currentPage: currentPage, pagesCount: pagesCount, handleClick: handleClick, isMobile: isMobile })))));
};

export { ListContainer as default };
//# sourceMappingURL=ListContainer.js.map
